import React, { useReducer } from "react";
import ThemeProvider from "../style/themeProvider";
import theme from "../style/theme";
import SettingsContext from "./SettingsContext";
import { MobileProvider } from "./MobileContext";
import HeaderHeightContext from "./HeaderContext";
import { ModalProvider } from "./ModalContext";
import PagePropContext from "./PagePropContext";
import BlogPropContext from "./BlogPropContext";
import FeatureFlagsContext from "./FeatureFlagsContext";
import { VisibleComponentsProvider } from "./VisibleComponentsContext";
import { HEADER_HEIGHT } from '../components/SiteNav';

export interface IGlobalContextProviderProps {
    settings?: object;
    pageProps?: object;
    blogProps?: object;
    featureFlags?: object;
    children:any;
};

export default (props:IGlobalContextProviderProps) => {
    const {settings={}, pageProps={}, blogProps={}, featureFlags={}, children} = props;
    return (
        <ThemeProvider theme={theme}>
            <SettingsContext.Provider value={settings}>
                <MobileProvider>
                    <HeaderHeightContext.Provider value={HEADER_HEIGHT}>
                        <ModalProvider headerHeight={HEADER_HEIGHT}>
                            <PagePropContext.Provider value={pageProps}>
                                <BlogPropContext.Provider value={blogProps}>
                                    <FeatureFlagsContext.Provider value={featureFlags}>
                                        <VisibleComponentsProvider>
                                            {children}
                                        </VisibleComponentsProvider>
                                    </FeatureFlagsContext.Provider>
                                </BlogPropContext.Provider>
                            </PagePropContext.Provider>
                        </ModalProvider>
                    </HeaderHeightContext.Provider>
                </MobileProvider>
            </SettingsContext.Provider>
        </ThemeProvider>
    )
}